import {
  clearCompletedMemberApplicationOperation,
  getOrCreateMemberApplicationOperation,
} from "../../Members/memberApplicationOperation";
import { CmpStaffCheckoutModeEnum } from "../../../../graphql/types";

export type ManageInvoiceCardCheckoutOperationInput = Readonly<{
  amountInCents: number;
  chamberId: string;
  fallbackForCheckoutSessionId?: string;
  installmentId?: string;
  invoiceId: string;
  isCmpInvoiceModuleTestData?: boolean;
  mode: CmpStaffCheckoutModeEnum;
}>;

export type PreparedManageInvoiceCardCheckoutOperation = Readonly<{
  input: ManageInvoiceCardCheckoutOperationInput & { operationId: string };
  operationId: string;
  storageKey: string;
}>;

const getManageInvoiceCardCheckoutStorageKey = ({
  chamberId,
  invoiceId,
}: Pick<ManageInvoiceCardCheckoutOperationInput, "chamberId" | "invoiceId">) =>
  `cmp-invoice-card-checkout-operation:v1:${encodeURIComponent(
    chamberId
  )}:${encodeURIComponent(invoiceId)}`;

export const prepareManageInvoiceCardCheckoutOperation = async (
  input: ManageInvoiceCardCheckoutOperationInput
): Promise<PreparedManageInvoiceCardCheckoutOperation> => {
  const storageKey = getManageInvoiceCardCheckoutStorageKey(input);
  const operation = await getOrCreateMemberApplicationOperation({
    request: input,
    storageKey,
  });

  return {
    input: { ...input, operationId: operation.operationId },
    operationId: operation.operationId,
    storageKey,
  };
};

export const completeManageInvoiceCardCheckoutOperation = (
  operation: PreparedManageInvoiceCardCheckoutOperation
) => {
  clearCompletedMemberApplicationOperation({
    operationId: operation.operationId,
    storageKey: operation.storageKey,
  });
};
